import { Batch } from "@/../../../packages/a4b-api/src/modules/Monetisation/Offerings/types"

export const deliveryOrderPayload = (data: any, batchId: string) => {
  let formattedTimeIso
  const pickupTime = new Date(data?.pickup_info?.pickup_time)
  let processedPickupTime
  if (isNaN(pickupTime.getTime())) {
    processedPickupTime = new Date()
  } else {
    processedPickupTime = new Date(data?.pickup_info?.pickup_time)
  }
  formattedTimeIso = processedPickupTime.toISOString()
  let payload: any = {
    ...data,
    pickup_info: {
      ...data.pickup_info,
      phone: data?.pickup_info?.phone?.toString() || '',
      email: data?.pickup_info?.email || '',
      pincode: data?.pickup_info?.pincode?.toString() || '',
      pickup_time: formattedTimeIso,
    },
    batch_id: batchId,
  }
  return payload
}

export const generateNameListText = (batchData: Batch | undefined) => {
  let text = `Batch ID/Code : ${batchData?.batch_code || batchData?.batch_id}\n\n`

  if (batchData?.transliterated_names) {
    batchData?.offering_names?.forEach((_, index) => {
      const offeringName = `${index + 1}. ${batchData?.transliterated_names?.hi[index]?.output_name || batchData?.transliterated_names?.hi[index]?.input_name} - [ ${batchData?.transliterated_names?.hi[index]?.input_name} ]`
      text += `${offeringName}${batchData.meta_data?.quantity_list?.[index] ? ` X ${batchData.meta_data?.quantity_list?.[index]}` : ''}\n`
    })
  } else {
    batchData?.offering_names?.forEach((item, index) => {
      text += `${index + 1}. ${item}${batchData?.meta_data?.quantity_list?.[index] ? ` X ${batchData?.meta_data?.quantity_list?.[index]}` : ''}\n`
    })
  }

  return text
}
